import { Row, Spacer, View } from "@amzn/stencil-react-components/layout";
import { H2 } from "@amzn/stencil-react-components/text";
import IconCheckCircleFillLarge from "@amzn/stencil-react-icons/icons/icon-check-circle-fill-large";
import * as React from "react";

type StatusBadgeProps = {
  isCompleted: boolean;
  isActive: boolean;
  activeStepIdx: number;
};

export default function StepStatus(props: StatusBadgeProps): JSX.Element {
  if (props.isCompleted) {
    return (
      <View color="green60" dataTestId="iconCheckCircleFill">
        <Spacer height={5} />
        <IconCheckCircleFillLarge
          className="completed-checkmark-status"
          aria-hidden={true}
        />
      </View>
    );
  } else {
    return (
      <View dataTestId="iconCheckCircleFillNotCompleted">
        <Spacer height={5} />
        <button
          className={props.isActive ? "active-step-btn" : "incomplete-step-btn"}
        >
          <span>{props.activeStepIdx + 1}</span>
        </button>
      </View>
    );
  }
}

/**
 * Get step header with the title and step status.
 *
 * @param onboardingStepIdx the onboarding step index assigned to the step.
 * @param isCompleted Is the onboarding step completed
 * @param isActive Is this step the active step? Active steps are highlighted differently.
 * @param titleText The step title
 * @param toggle The toggle function to expand the expander.
 */
export const getStepHeader = (
  onboardingStepIdx: number,
  isCompleted: boolean,
  isActive: boolean,
  titleText?: string,
  toggle?: () => void
): JSX.Element => (
  <Row aria-hidden={true} columnGap="S400" onClick={toggle}>
    <StepStatus
      activeStepIdx={onboardingStepIdx}
      isCompleted={isCompleted}
      isActive={isActive}
    />
    <H2 fontWeight="normal" className="step-title-header-text">
      {titleText}
    </H2>
  </Row>
);
